﻿import * as paths from './paths';
export default class HeatmapConfigurator {
    constructor(configContainer, rootURL, settings, resourcesHandler, additional) {
        this.resourcesHandler = resourcesHandler;
        this.configContainer = configContainer;
        this.rootURL = rootURL;
        this.settings = settings;
        this.radiusId = 'radius-id';
        this.blurId = 'blur-id';
        this.entityId = 'entity-id';
        this.entityFieldId = 'entity-field-id';
        this.defaultWeightId = 'default-weight-id';
        this.colorPickersId = 'color-pickers-id';
        this.rampCounter = 0;
        this.additional = additional;
    }

    init() {
        this._ensureHeatmapStyles();
        this.configContainer.innerHTML = this._getTemplate();

        $("#" + this.radiusId).kendoNumericTextBox({
            format: "0",
            decimals: 0,
            min: 0,
            appendTo: '#' + this.radiusId
        });

        if (this.settings.Radius != null) {
            $("#" + this.radiusId).data('kendoNumericTextBox').value(this.settings.Radius);
        }

        $("#" + this.blurId).kendoNumericTextBox({
            format: "0",
            decimals: 0,
            min: 0,
            appendTo: '#' + this.blurId
        });

        if (this.settings.Blur != null) {
            $("#" + this.blurId).data('kendoNumericTextBox').value(this.settings.Blur);
        }

        $("#" + this.defaultWeightId).kendoNumericTextBox({
            format: "n2",
            decimals: 2,
            min: 0,
            max: 1,
            step: 0.05,
            appendTo: '#' + this.defaultWeightId
        });

        $("#" + this.defaultWeightId).data('kendoNumericTextBox').value(
            this.settings.DefaultWeight != null ? this.settings.DefaultWeight : 0.3
        );

        if (this.additional == null || this.additional.idEntity == null) {
            $('#' + this.entityId).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityId,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return this.rootURL + paths.MAP_ENTITY_LAYERS;
                            }
                        }
                    }
                },
                change: (evt) => {
                    $('#' + this.entityFieldId).data("kendoComboBox").value(null);
                    $('#' + this.entityFieldId).data("kendoComboBox").dataSource.read();
                }
            });

            if (this.settings.IdEntity) {
                $('#' + this.entityId).data("kendoComboBox").value(this.settings.IdEntity);
            }
        } else {
            $('#' + this.entityId).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityId,
                dataSource: []
            });

            $('#' + this.entityId).data("kendoComboBox").value(this.additional.idEntity);
            $('#id-entity-wrapper').hide();
            $('#' + this.entityFieldId).closest('.col-4').removeClass('col-4').addClass('col-6');
            $('#' + this.defaultWeightId).closest('.col-4').removeClass('col-4').addClass('col-6');
        }

        let isEntity = (this.additional == null || this.additional.Type != 'Geoservice') ? true : false

        if (this.additional == null || this.additional.fields == null) {
            $('#' + this.entityFieldId).kendoComboBox({
                dataTextField: 'FieldName',
                dataValueField: 'FieldName',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityFieldId,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                if (isEntity) {
                                    return this.rootURL + paths.MAP_ENTITY_GET_FIELDS + $('#' + this.entityId).data('kendoComboBox').value();
                                } else {
                                    return this.rootURL + paths.MAP_GEOSERVICE_FIELDS + $('#' + this.entityId).data('kendoComboBox').value();
                                }
                            }
                        }
                    }
                }
            });

            if (this.settings.IdEntityField != null) {
                $('#' + this.entityFieldId).data('kendoComboBox').value(this.settings.IdEntityField);
            }
        } else {
            $('#' + this.entityFieldId).kendoComboBox({
                dataTextField: 'FieldName',
                dataValueField: 'FieldName',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityFieldId,
                dataSource: this.additional.fields
            });

            if (this.settings.IdEntityField != null) {
                $('#' + this.entityFieldId).data('kendoComboBox').value(this.settings.IdEntityField);
            }
        }

        if (this.settings.ColorRamp == null || this.settings.ColorRamp.length == 0) {
            this.settings.ColorRamp = ["#FF0000", "#FFFF00", "#00FF00"];
        }

        const container = document.getElementById(this.colorPickersId);
        container.innerHTML = `<div class="xp-heatmap-ramp-list"></div>
                               <button type="button" class="xp-heatmap-ramp-add" title="${this.resourcesHandler.get('Add') || 'Add'}">
                                   <i class="fal fa-plus"></i>
                               </button>`;

        this.settings.ColorRamp.forEach(color => this._appendRampItem(color));

        $('#' + this.colorPickersId).on('click', '.xp-heatmap-ramp-remove', evt => {
            const $row = $(evt.currentTarget).closest('.xp-heatmap-ramp-item');
            const picker = $row.find('.ramp-color').data('kendoColorPicker');
            if (picker != null) picker.destroy();
            $row.remove();
        });

        $('#' + this.colorPickersId).on('click', '.xp-heatmap-ramp-add', () => {
            this._appendRampItem('#ffffff');
        });
    }

    _appendRampItem(color) {
        const id = 'ramp-color-' + (++this.rampCounter);
        const row = document.createElement('div');
        row.className = 'xp-heatmap-ramp-item';
        row.innerHTML = `<input class="ramp-color" id="${id}">
                         <button type="button" class="xp-heatmap-ramp-remove" title="${this.resourcesHandler.get('Remove') || 'Remove'}">
                             <i class="fal fa-times"></i>
                         </button>`;
        $('#' + this.colorPickersId + ' .xp-heatmap-ramp-list').append(row);
        $('#' + id).kendoColorPicker({ value: color });
    }

    save() {
        const ramps = [];
        $('#' + this.colorPickersId + ' .ramp-color').each(function () {
            const picker = $(this).data('kendoColorPicker');
            ramps.push(picker != null ? picker.value() : this.value);
        });

        return {
            Radius: $("#" + this.radiusId).data('kendoNumericTextBox').value(),
            Blur: $("#" + this.blurId).data('kendoNumericTextBox').value(),
            IdEntity: $('#' + this.entityId).data("kendoComboBox").value(),
            IdEntityField: $('#' + this.entityFieldId).data('kendoComboBox').value(),
            DefaultWeight: $("#" + this.defaultWeightId).data('kendoNumericTextBox').value(),
            ColorRamp: ramps,
            Type: 'HEATMAP'
        };
    }

    _ensureHeatmapStyles() {
        if (document.getElementById('xp-heatmap-styles')) return;

        const style = document.createElement('style');
        style.id = 'xp-heatmap-styles';
        style.textContent =
            '.xp-heatmap-section-title {' +
                'display:flex;align-items:center;gap:10px;' +
                'margin:14px 0 10px 0;padding:0;' +
                'font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;' +
                'color:var(--theme-primary-700);' +
            '}' +
            '.xp-heatmap-section-title::after {' +
                'content:"";flex:1;height:1px;background:var(--theme-primary-700);opacity:0.25;' +
            '}' +
            '.xp-heatmap-section-title:first-child {' +
                'margin-top:4px;' +
            '}' +
            '.xp-heatmap-form .form-label {' +
                'font-size:12px;margin-bottom:3px;color:#555;font-weight:500;' +
            '}' +
            '.xp-heatmap-form .col-4.mb-3,' +
            '.xp-heatmap-form .col-6.mb-3,' +
            '.xp-heatmap-form .col-12.mb-3 {' +
                'margin-bottom:10px !important;' +
            '}' +
            '.xp-heatmap-form .k-colorpicker {' +
                'border-radius:4px;' +
            '}' +
            '.xp-heatmap-ramp-container {' +
                'display:flex;align-items:center;flex-wrap:wrap;gap:8px;' +
                'padding:8px;border:1px solid #E5E5E5;border-radius:4px;background:#fff;' +
            '}' +
            '.xp-heatmap-ramp-list {' +
                'display:flex;align-items:center;gap:8px;flex-wrap:wrap;' +
            '}' +
            '.xp-heatmap-ramp-item {' +
                'display:flex;align-items:center;gap:4px;' +
            '}' +
            '.xp-heatmap-ramp-remove,' +
            '.xp-heatmap-ramp-add {' +
                'border:1px solid transparent;background:transparent;' +
                'width:22px;height:22px;border-radius:50%;padding:0;' +
                'display:inline-flex;align-items:center;justify-content:center;' +
                'cursor:pointer;font-size:12px;transition:background 0.15s ease,border-color 0.15s ease;' +
            '}' +
            '.xp-heatmap-ramp-remove { color:#d7191c; }' +
            '.xp-heatmap-ramp-remove:hover { background:rgba(215,25,28,0.1);border-color:#d7191c; }' +
            '.xp-heatmap-ramp-add { color:var(--theme-primary-700); }' +
            '.xp-heatmap-ramp-add:hover { background:rgba(0,0,0,0.05);border-color:var(--theme-primary-700); }';

        document.head.appendChild(style);
    }

    _getTemplate() {
        const r = this.resourcesHandler;
        return `<div class="form-group col-12 xp-heatmap-form">
                    <div class="col-12 xp-heatmap-section-title">${r.get('HeatmapSection_Appearance')}</div>
                    <div class="form-row">
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('Radius')}</label>
                                <input class="form-control" id="${this.radiusId}">
                            </div>
                        </div>
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('Blur')}</label>
                                <input class="form-control" id="${this.blurId}">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 xp-heatmap-section-title">${r.get('HeatmapSection_Weighting')}</div>
                    <div class="form-row">
                        <div class="col-4 mb-3" id="id-entity-wrapper">
                            <div class="form-group">
                                <label class="form-label">${r.get('Entity')}</label>
                                <div class="form-control" id="${this.entityId}"></div>
                            </div>
                        </div>
                        <div class="col-4 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('WeightField')}</label>
                                <input class="form-control" id="${this.entityFieldId}">
                            </div>
                        </div>
                        <div class="col-4 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('DefaultWeight')}</label>
                                <input class="form-control" id="${this.defaultWeightId}">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 xp-heatmap-section-title">${r.get('ColorRamp')}</div>
                    <div class="form-row">
                        <div class="col-12 mb-3">
                            <div class="xp-heatmap-ramp-container" id="${this.colorPickersId}"></div>
                        </div>
                    </div>
                </div>`;
    }
}